const formatPrice = (price) => {
  return `$${price}.00`;
};
export default formatPrice;
